document.addEventListener(
	'DOMContentLoaded',
	function () {
		const bodyPage = document.body;

		const highContrastMode = (event) => {
			const isChecked = event.target.checked;
			bodyPage.classList.toggle('high-contrast', isChecked);
			localStorage.setItem('high-contrast', isChecked ? 'enabled' : 'disabled');

			// Directly select elements with both the class and data-variant attribute
			document.querySelectorAll('.toggle-contrast[data-variant]').forEach((switchElement) => {
				const checkbox = document.getElementById(switchElement.dataset.variant);
				if (checkbox) checkbox.checked = isChecked;
			});
		};

		const initializeHighContrast = () => {
			const isEnabled = localStorage.getItem('high-contrast') === 'enabled';
			bodyPage.classList.toggle('high-contrast', isEnabled);

			// Reuse the same logic for checkboxes on initialization
			document.querySelectorAll('.toggle-contrast[data-variant]').forEach((switchElement) => {
				const checkbox = document.getElementById(switchElement.dataset.variant);
				if (checkbox) checkbox.checked = isEnabled;
			});
		};

		// Add the event listener to the checkboxes
		document.querySelectorAll('.toggle-contrast[data-variant]').forEach((switchElement) => {
			const checkbox = document.getElementById(switchElement.dataset.variant);
			if (checkbox) checkbox.addEventListener('click', highContrastMode);
		});

		// Initialize high contrast on page load
		initializeHighContrast();
	},
	false,
);
